const firebaseConfig = {
    apiKey: "AIzaSyCwQOBW0tOyBXbvFHXhWs6CST-EglVznPY",
    authDomain: "volunteer-network-bf18c.firebaseapp.com",
    databaseURL: "https://volunteer-network-bf18c.firebaseio.com",
    projectId: "volunteer-network-bf18c",
    storageBucket: "volunteer-network-bf18c.appspot.com",
    messagingSenderId: "425382078898",
    appId: "1:425382078898:web:681c2f9610b156983e9cab"
};

export default firebaseConfig;